/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./extension');

// MapSDK
const { useMapConfig } = require('@xenodrive/vue-map-sdk');
useMapConfig(require('~/config/map.config.ts').default);

// window.Vue = require('vue').default;

// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */

// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// const app = new Vue({
//     el: '#app',
// });

// outside modules

window.moment = require('moment');
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min.js')
window.toastr = require('toastr');
require('select2');
require('popper.js/dist/popper.min.js');
require('tempusdominus-bootstrap-4');
require('multiple-select/dist/multiple-select.min');
require('bs-stepper/dist/js/bs-stepper.min.js');
require('tree-multiselect/dist/jquery.tree-multiselect.min.js');
require('datatables.net-bs4/js/dataTables.bootstrap4.min.js');
window.YubinBango = require('yubinbango-core2');
require('jquery-ui/ui/widgets/sortable.js');
window.holiday = require('holiday-jp');
window.holidayJp = require('@holiday-jp/holiday_jp');
window.FullCalendar = require('fullcalendar-scheduler');


// original modules

require('./modules/funcitons');

window._complete = require('./modules/complete');
window._error = require('./modules/error');
window._ajax = require('./modules/ajax');
window._overlay = require('./modules/overlay');
window._modal = require('./modules/modal');
window._request = require('./modules/request');
window._format = require('./modules/format');
window._select = require('./modules/select');

import zdcMap from "./modules/zdc-map.js";
window._zdcMap = zdcMap;


// common sctipt files

// require('./common/firebase');
require('./common/affiliation');
require('./common/datatable');
require('./common/dropdown');
require('./common/message');
require('./common/overlay');
require('./common/search');
require('./common/select');
require('./common/inputs');
require('./common/dnd');
require('./common/step');
require('./common/file');
require('./common/sidebar');
require('./common/initialize');
require('./common/button');
require('./common/csv');

// pages sctipt files

require('./pages/login.index');
require('./pages/setup.index');
require('./pages/dashboard.index');
require('./pages/holding.index');
require('./pages/company.index');
require('./pages/section.index');
require('./pages/account.index');
require('./pages/group.index');
require('./pages/user.index');
require('./pages/vehicle.index');
// require('./pages/rollcall.index');
require('./pages/attendance.index');
// require('./pages/diagnosis.index');
// require('./pages/occupation.index');
// require('./pages/employment.index');
// require('./pages/post.index');
require('./pages/information.index');
require('./pages/vehicle.index');
require('./pages/contract.index');
require('./pages/measurement.index');
require('./pages/device.index');
require('./pages/mail_setting.index');
require('./pages/terminal.index');
require('./pages/news_release.index');
require('./pages/client_download.index');
require('./pages/daily_check_result.index');
require('./pages/daily_check_item.index');
require('./pages/shipping_information.index');
require('./pages/drive_report.index');
require('./pages/carbon_ops.index');
require('./pages/refuel.index');
require('./pages/reserve_transfer_user.index');
require('./pages/reserve_transfer_vehicle.index');
require('./pages/scheduled_holiday.index');
require('./pages/paid_holiday_config.index');
require('./pages/password_forgot.index');
require('./pages/license_setting.index');
require('./pages/termination.index');
require('./pages/vehicle_reservation.index');
require('./pages/operation_history.index');
require('./pages/extension_setting.index');
require('./pages/event_video.index');
require('./pages/safety_drive.index');
require('./pages/option_setting.index');
require('./pages/yuricargo_vehicles_config.index');
require('./pages/version.index');
require('./pages/csv_download_job.index');
require('./pages/drive_recorder.index');
require('./pages/safety_guidance.index');
require('./pages/movement.index');
require('./pages/export_logs.index');
